import { render } from "./SectionContact1.vue?vue&type=template&id=7ae3d95a&scoped=true"
import script from "./SectionContact1.vue?vue&type=script&lang=js"
export * from "./SectionContact1.vue?vue&type=script&lang=js"

import "./SectionContact1.vue?vue&type=style&index=0&id=7ae3d95a&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae3d95a"]])

export default __exports__